module.exports = __webpack_public_path__ + "static/media/pin.80638eb0.svg";